// extracted by mini-css-extract-plugin
export default {"cls1":"SidebarSection-cls1_mEa","cls2":"SidebarSection-cls2_LTD SidebarSection-cls1_mEa"};